/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

/**
 * Enum to distinguish different categories of units.
 */
export enum EnumUnit {
    /**
     * Countable units
     */
    Numerable = 1,
    /**
     * Fixed fee, regardless of quantity
     */
    FixedFee = 2,
    /**
     * A unit which describes a percentage. Usually used in combination with a second quantity
     */
    Percent = 3,
    /**
     * weight measure in kilograms
     */
    Kilogram = 10,
    /**
     * weight measure in tons
     */
    Ton = 11,
    /**
     * weight measure in grams
     */
    Gram = 12,
    /**
     * volume measure in liters
     */
    Liter = 20,
    /**
     * volume measure in cubic meters
     */
    CubicMeter = 21,
    /**
     * time measure in hours
     */
    Hours = 30,
    /**
     * time measure in days
     */
    Days = 31,
    /**
     * distance measure in kilometers
     */
    Kilometers = 41,
}
